/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Effect from './Effect';

/** @hidden */
const ccclass = cc._decorator.ccclass;
/** @hidden */
const property = cc._decorator.property;

/** An effect for triggering a [[cc.ParticleSystem]]. */
@ccclass
export default class ParticleEffect extends Effect
{
    /** The referenced [[cc.ParticleSystem]]. */
    @property({ type: cc.ParticleSystem, visible: true })
    private _particle: cc.ParticleSystem = null;

    @property()
    protected setActive: boolean = true;

    /** Executes the referenced [[cc.ParticleSystem]]. */
    protected trigger = (): void =>
    {
        if (this.setActive) { this.node.active = true; }

        this._particle.resetSystem();
        this.complete();
    }

    /** Manually stop the referenced [[cc.ParticleSystem]]. */
    public StopSystem(): void
    {
        this._particle.stopSystem();
    }

    /** Stops the in-progress effect or its next trigger. */
    public Stop(): void
    {
        super.Stop();

        this._particle.stopSystem();
    }
}
